import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Text } from "@pentabd/ui";

import { MultiFileRow } from "@components";

import {
  SUPPORTING_DOCUMENT,
  ReleaseFormDataType,
} from "@validations/HRM/release/releaseFormValidation";

export const SupportingDocument = ({ isDisabled }: { isDisabled: boolean }) => {
  const { t } = useTranslation();

  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = useFormContext<ReleaseFormDataType>();

  return (
    <>
      <Text
        weight="semibold"
        size="lg"
        color="dark"
        className="mb-8 pb-8 d-block border-bottom"
      >
        {t("RELEASE_DETAILS.FORM.SUPPORTING_DOC.LABEL")}
      </Text>
      <MultiFileRow
        name={SUPPORTING_DOCUMENT}
        control={control}
        setValue={setValue}
        register={register}
        error={errors}
        fileDetails={["documentName", "date", "remarks", "memorialNo"]}
        disabled={isDisabled}
      />
    </>
  );
};
